<template>
	<div>
		<headerBox :current="111"></headerBox>
		<bannerBox ref="bannerChild" :bgNum="bgNum"></bannerBox>
		<div class="content_box">
			<div class="title">{{newInfo.title}}</div>
			<div class="line_box">
				<div class="time">发布时间：{{newInfo.date}}</div>
				<div class="ly">来源：{{newInfo.source||'暂无'}}</div>
				<div class="share">
					<Tooltip content="Top Center text" placement="top">
						<img src="@/assets/images/wx.png"/>
						<img slot="content" class="qrcode" :src="newInfo.qrcode"/>
					</Tooltip>
					<img @click="goWb" src="@/assets/images/wb.png"/>
				</div>
			</div>
			<div class="content" v-html="newInfo.content"></div>
		</div>
		<footerBox></footerBox>
		<Back-top :height="100" :bottom="200">
			<div class="iconfont icon-shangjiantou"></div>
		</Back-top>
	</div>
</template>

<script>
	import bannerBox from '@/components/banner.vue'
	import headerBox from '@/components/header.vue'
	import footerBox from '@/components/footer.vue'
	import {
		getDetatilArticle
	} from '@/api/home/index'
	export default {
		name: 'home',
		components: {
			bannerBox,
			headerBox,
			footerBox,
		},
		data() {
			return {
				newInfo: {},
				total: 0,
				params: {
					pageNo: 1,
					pageSize: 6
				},
				catid: '',
				bgNum:0
			}

		},
		mounted() {
			this.getDetatilArticle();
			if (this.$route.params.locationList) {
				let locationList = JSON.parse(decodeURIComponent(this.$route.params.locationList));
				this.$refs["bannerChild"].locationList = locationList;
			}
			if(this.$route.params.bgNum){
				this.bgNum = this.$route.params.bgNum;
			}
		},
		methods: {
			/* ====================数据请求部分========================== */
			getDetatilArticle() {
				getDetatilArticle({
					id: this.$route.query.id,
				}).then(res => {
					if (res.code == 200 || res.code == 0) {
						let newInfo = res.result;
						this.newInfo = newInfo
						this.total = res.result.total;
						let height = document.documentElement.clientHeight-50;
						this.newInfo.content = this.newInfo.content.replace(/\<iframe/gi, `<iframe style="height:${height}px" ` );
					} else {
						this.infoList = [];
					}
				})
			},
			/* ====================页面交互部分========================== */
			changePage(e) {
				this.params.pageNo = e;
				this.getArticle()
			},
			goDetail(it) {
				this.$router.push({
					name: '/news_detail'
				})
			},
			goWb(){
				window.open(this.newInfo.weibo, '_blank')
			},
		}
	}
</script>

<style lang="scss">
	.content_box {
		font-size: 15px;
		margin: 80px 200px;
		min-width: 1100px;

		.title {
			font-size: 22px;
			text-align: center;
		}
		.ly{
			font-size: 13px;
		}
		.line_box{
			padding: 50px 0 5px;
			border-bottom: 1px solid #eee;
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			.time {
				font-size: 13px;
			}
			.share{
				display: flex;
				img{
					height: 25px;
					margin: 0 10px;
					cursor: pointer;
				}
				.qrcode{
					height: 100px;
				}
			}
		}

	}
</style>
